export default __webpack_public_path__ + "static/media/mask15.fd2605a4.jpeg";